import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';
import { NgIf } from '@angular/common';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'satisfaction-cell-renderer',
  standalone: true,
  imports: [NgIf],
  template: `
    <div *ngIf="value" class="tag {{ value + 'Tag' }}">
    </div>
  `,
  styles: [
    `
      :host {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
      }
      span {
        text-align: center;
        width: 100%;
      }
      .tag {
        &:after {
          content: "";
          width: 20px;
          height: 20px;
          position: absolute;
          transform: translate(-50%);
          background: red;
          border-radius: 50%;
        }
      }
      .PositiveTag {
        &:after {
          background: #4CAF50;
        }
      }
      .NeutralTag {
        &:after {
          background: #9E9E9E;
        }
      }
      .NegativeTag {
        &:after {
          background: #F44336;
        }
      }
    `,
  ],
})
export class SatisfactionCellRendererComponent implements ICellRendererAngularComp {
  public value?: any;

  agInit(params: ICellRendererParams): void {
    this.value = params.value;
  }

  refresh(params: ICellRendererParams): boolean {
    this.value = params.value;
    return true;
  }
}